import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'comunaFilterPipe',
  pure: false
})
export class ComunaFilterPipe implements PipeTransform {
  transform(items: any[], comunaStr): any {
    if (!items || !comunaStr) {
      return items;
    }
    return items.filter(
      item => item.nombre.toLowerCase().indexOf(comunaStr.toLowerCase()) > -1
    );
  }
}

@Pipe({
  name: 'diaFilterPipe',
  pure: false
})
export class DiaFilterPipe implements PipeTransform {
  transform(items: any[], diaStr): any {
    if (!items || !diaStr) {
      return items;
    }
    return items.filter(item => item.texto.indexOf(diaStr) > -1);
  }
}

@Pipe({
  name: 'empresaFilterPipe',
  pure: false
})
export class EmpresaFilterPipe implements PipeTransform {
  transform(items: any[], empresaStr): any {
    if (!items || !empresaStr) {
      return items;
    }
    return items.filter(item => {
      return (
        (item['sigla'] &&
          item['sigla'].toLowerCase().indexOf(empresaStr.toLowerCase()) > -1) ||
        (item.sigla &&
          item.sigla.toLowerCase().indexOf(empresaStr.toLowerCase()) > -1)
      );
    });
  }
}

@Pipe({
  name: 'procesoFilterPipe',
  pure: false
})
export class ProcesoFilterPipe implements PipeTransform {
  transform(items: any[], procesoStr): any {
    if (!items || !procesoStr) {
      return items;
    }
    return items.filter(item => {
      return (
        (item.nombre &&
          item.nombre.toLowerCase().indexOf(procesoStr.toLowerCase()) > -1) ||
        (item.sigla &&
          item.sigla.toLowerCase().indexOf(procesoStr.toLowerCase()) > -1)
      );
    });
  }
}
